var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mt-4",attrs:{"cols":"12"}},[_c('LineChartNaf',{ref:"linechart",attrs:{"chart-data":_vm.data,"options":_vm.options,"gradient":_vm.gradient},on:{"generated":_vm.setLegend}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }